import { OrderListprops } from "../../../../Component/Interface/Order";
import RenderMultiRows2, {
  HeaderRow,
  Row,
  Table,
  TableHeader,
} from "../../../../Component/style/orderTable_style2";

const Order_all = ({ list }: OrderListprops) => {
  return (
    <>
      <TableHeader $width={140} style={{ borderLeft: "1px solid #8e8e8e" }}>
        <HeaderRow $width={6}>주문상태</HeaderRow>
        <HeaderRow $width={10}>상태변경일</HeaderRow>
        <HeaderRow>주문자</HeaderRow>
        <HeaderRow $width={6}>입금자</HeaderRow>
        <HeaderRow $width={10}> 주문일시</HeaderRow>
        <HeaderRow $width={6}>상품 번호</HeaderRow>
        <HeaderRow>품목명</HeaderRow>
        <HeaderRow>옵션</HeaderRow>
        <HeaderRow>단가</HeaderRow>
        <HeaderRow $width={6}>수량</HeaderRow>
        <HeaderRow>총 금액</HeaderRow>
        <HeaderRow $width={6}>택배비</HeaderRow>
        <HeaderRow>총 결제금액</HeaderRow>
        <HeaderRow $width={8}>받는 분</HeaderRow>
        <HeaderRow>받는 분 전화</HeaderRow>
        <HeaderRow $width={6}>받는분 우편번호</HeaderRow>
        <HeaderRow className="flex3">받는분총주소</HeaderRow>
      </TableHeader>

      {list.map((data, idx) => {
        const rowHeight = data.order_details.length || 1;
        const total_payment = data.total_payment.toLocaleString("ko-KR");

        return (
          <Table
            key={idx}
            className={idx % 2 === 0 ? "" : "x2"}
            $width={140}
            $height={rowHeight}
          >
            {[
              { key: "주문상태", width: 6 },
              { key: "상태변경일", width: 10 },
              { key: "주문자", field: data.order_name },
              { key: "입금자", width: 6, field: data.order_nickname },
              { key: "주문일시", width: 10 },
              { key: "상품번호", width: 6 },
              { key: "품목명" },
              { key: "옵션" },
              { key: "단가" },
              { key: "수량", width: 6 },
            ].map(({ key, width, field }) => (
              <Row key={key} $width={width}>
                {field || (
                  <RenderMultiRows2
                    detailData={data.order_details}
                    searchkey={key}
                  />
                )}
              </Row>
            ))}

            <Row>
              <RenderMultiRows2
                detailData={data.order_details}
                searchkey={"총 금액"}
              />
            </Row>
            <Row $width={6}>{data.delivery_price}</Row>
            <Row>{total_payment}</Row>
            <Row $width={8}>{data.addr_recipient}</Row>
            <Row>{data.addr_phone}</Row>
            <Row $width={6}>{data.addr_num}</Row>
            <Row className="flex3 last">{`${data.addr_basic} ${data.addr_detail}`}</Row>
          </Table>
        );
      })}
    </>
  );
};

export default Order_all;
